module.exports = __webpack_public_path__ + "static/media/LQ_Jacquard_Meda_Ind.Blue_Peri.987fb854.png";